import { request, removeEmptyAttribute } from "../helpers/utility";

let instance = null;

export default class ServiceResources {
    constructor() {
        if (!instance) {
            this.url = 'admin/services';
            instance = this;
        }
        return instance;
    }

    get() {
        return request.GET(this.url)
    }
}
